import { Switch } from 'react-router-dom';
import DefaultLayout from './pages/layouts/Default';
import LoginLayout from './pages/layouts/Login';

import Login from './pages/Login';
import Dashboard from './pages/dashboard';

import AssetCats from './pages/cmaster/AssetCats';
import StationPoint from './pages/cmaster/StationPoint';
import Manufacturer from './pages/cmaster/Manufacturer';
import ServiceProvider from './pages/cmaster/ServiceProvider';
import Vendor from './pages/cmaster/Vendor';
import Uom from './pages/cmaster/Uom';
import Model from './pages/cmaster/Model';
import Items from './pages/cmaster/Items';

import Facilities from './pages/Facilities';

import User from './pages/user/User';
import Role from './pages/user/Role';

import Assets from './pages/assets/Assets';
import ExpenditureIncome from './pages/assets/ExpenditureIncome';
import TransferOut from './pages/assets/TransferOut';
import TransferIn from './pages/assets/TransferIn';
import StockRequest from './pages/assets/StockRequest';
import Ticket from './pages/ticket/Ticket';

import StockTransactions from './pages/reports/StockTransactions';

import Profile from './pages/user/Profile';

import Maintenance from './pages/reports/Maintenance';
import AssetMovement from './pages/reports/AssetMovement';
import JobAllocation from './pages/reports/JobAllocation';
import Asset1 from './pages/reports/Asset1';
import UnTicket from './pages/reports/UnTicket';
import Service from './pages/reports/Service';
import Logs from './pages/reports/Logs';
import Dashboards from './pages/reports/Dashboards';
import Levels from './pages/reports/Levels';
import AdHocReportBuilde from './pages/assets/AdHocReportBuilde';

import FleetDashboard from './pages/fleet/FleetDashboard';
import FleetReports from './pages/fleet/FleetReports';
import FleetAssignments from './pages/fleet/FleetAssignments';
import FleetTripLogs from './pages/fleet/FleetTripLogs';
import FleetIncidents from './pages/fleet/FleetIncidents';
import FleetDisposals from './pages/fleet/FleetDisposals';
import FleetDeployments from './pages/fleet/FleetDeployments';
import FleetMaintenance from './pages/fleet/FleetMaintenance';
import FleetNoticeBoard from './pages/fleet/FleetNoticeBoard';
import FleetAuditLog            from './pages/fleet/FleetAuditLog';
import FleetAnalyticsExec        from './pages/fleet/analytics/FleetAnalyticsExec';
import FleetAnalyticsDepreciation from './pages/fleet/analytics/FleetAnalyticsDepreciation';
import FleetAnalyticsCostPerKm   from './pages/fleet/analytics/FleetAnalyticsCostPerKm';
import FleetAnalyticsRepairReplace from './pages/fleet/analytics/FleetAnalyticsRepairReplace';
import FleetAnalyticsProgrammeCost from './pages/fleet/analytics/FleetAnalyticsProgrammeCost';
import FleetAnalyticsDriverScorecard from './pages/fleet/analytics/FleetAnalyticsDriverScorecard';
import FleetAnalyticsUtilisation      from './pages/fleet/analytics/FleetAnalyticsUtilisation';
import FleetAnalyticsFuelIntelligence from './pages/fleet/analytics/FleetAnalyticsFuelIntelligence';
import FleetFuelTopup from './pages/fleet/FleetFuelTopup';
import FleetAnalyticsDeployments      from './pages/fleet/analytics/FleetAnalyticsDeployments';

export default function Routes() {
    return (
        <Switch>
            <LoginLayout path="/" exact component={Login} />

            <DefaultLayout path="/dashboard" component={Dashboard} />

            <DefaultLayout path="/profile" component={Profile} />
            <DefaultLayout path="/users" component={User} />
            <DefaultLayout path="/roles" component={Role} />

            <DefaultLayout path="/facilities" component={Facilities} />
            <DefaultLayout path="/asset-cats" component={AssetCats} />
            <DefaultLayout path="/station-points" component={StationPoint} />
            <DefaultLayout path="/manufacturers" component={Manufacturer} />
            <DefaultLayout path="/service-providers" component={ServiceProvider} />
            <DefaultLayout path="/vendors" component={Vendor} />
            <DefaultLayout path="/items" component={Items} />
            <DefaultLayout path="/uoms" component={Uom} />
            <DefaultLayout path="/models" component={Model} />

            <DefaultLayout path="/assets-list" component={Assets} />
            <DefaultLayout path="/expenditureIncome" component={ExpenditureIncome} />
            <DefaultLayout path="/transfer-out" component={TransferOut} />
            <DefaultLayout path="/transfer-in" component={TransferIn} />
            <DefaultLayout path="/stock-request" component={StockRequest} />
            <DefaultLayout path="/job-cards" component={Ticket} />

            <DefaultLayout path="/stock-transactions-report" component={StockTransactions} />
            <DefaultLayout path="/asset-report" component={Asset1} />
            <DefaultLayout path="/dashboards-report" component={Dashboards} />
            <DefaultLayout path="/levels-report" component={Levels} />
            <DefaultLayout path="/maintenance-report" component={Maintenance} />
            <DefaultLayout path="/job-allocation-report" component={JobAllocation} />
            <DefaultLayout path="/asset-movement-report" component={AssetMovement} />
            <DefaultLayout path="/unassigned-tickets" component={UnTicket} />
            <DefaultLayout path="/routine-service" component={Service} />
            <DefaultLayout path="/adhoc-report" component={AdHocReportBuilde} />
            <DefaultLayout path="/logs-audit" component={Logs} />

            {/* ── Fleet Management Routes ── */}
            <DefaultLayout path="/fleet-notice-board" component={FleetNoticeBoard} />
            <DefaultLayout path="/fleet-audit-log"    component={FleetAuditLog} />
            <DefaultLayout path="/fleet-analytics-exec"             component={FleetAnalyticsExec} />
            <DefaultLayout path="/fleet-analytics-depreciation"     component={FleetAnalyticsDepreciation} />
            <DefaultLayout path="/fleet-analytics-cost-per-km"      component={FleetAnalyticsCostPerKm} />
            <DefaultLayout path="/fleet-analytics-repair-replace"   component={FleetAnalyticsRepairReplace} />
            <DefaultLayout path="/fleet-analytics-programme-cost"   component={FleetAnalyticsProgrammeCost} />
            <DefaultLayout path="/fleet-analytics-driver-scorecard" component={FleetAnalyticsDriverScorecard} />
            <DefaultLayout path="/fleet-analytics-utilisation"        component={FleetAnalyticsUtilisation} />
            <DefaultLayout path="/fleet-analytics-fuel-intelligence" component={FleetAnalyticsFuelIntelligence} />
            <DefaultLayout path="/fleet-analytics-deployments"       component={FleetAnalyticsDeployments} />
            <DefaultLayout path="/fleet-dashboard" component={FleetDashboard} />
            <DefaultLayout path="/fleet-assignments" component={FleetAssignments} />
            <DefaultLayout path="/fleet-trip-logs" component={FleetTripLogs} />
            <DefaultLayout path="/fleet-incidents" component={FleetIncidents} />
            <DefaultLayout path="/fleet-disposals" component={FleetDisposals} />
            <DefaultLayout path="/fleet-deployments" component={FleetDeployments} />
            <DefaultLayout path="/fleet-maintenance" component={FleetMaintenance} />
            <DefaultLayout path="/fleet-reports" component={FleetReports} />
            <DefaultLayout path="/fleet/report-service-due" component={FleetReports} />
            <DefaultLayout path="/fleet/report-lifespan" component={FleetReports} />
            <DefaultLayout path="/fleet/report-chronic" component={FleetReports} />
            <DefaultLayout path="/fleet/report-drivers" component={FleetReports} />
            <DefaultLayout path="/fleet/report-tco" component={FleetReports} />
            <DefaultLayout path="/fleet/report-documents" component={FleetReports} />
            <DefaultLayout path="/fleet/report-status" component={FleetReports} />
            <DefaultLayout path="/fleet/report-fuel" component={FleetReports} />
            <DefaultLayout path="/fleet/report-ageing" component={FleetReports} />
            <LoginLayout component={Login} />
        </Switch>
    );
}